import { search } from "./newsSummary"

// 検索用イベント
search();
